module.exports = __webpack_public_path__ + "static/about_meeting-5c3dba3bd48b172279bb1c624da0eb35.jpg";